import './app.css'
import { Footer } from './Footer';
import { css, l, type ClassComponent } from "./lib";
import { stFlexyButton } from './NavbarFlexyButton';
import { WorkStages } from './WorksStages';
import { YourProblemsAndTasks } from './YourProblemsAndTasks';
import { ImportantProjects } from './ImportantProjects';
import { TitleAndDescription } from './TitleAndDescription';
import { KeyPeople } from './KeyPeople';
import { Services } from './Services';
import { Blog } from './Blog';
import { linkToPresentation } from './constants';

function MenuCloser(tag: HTMLAnchorElement) {
    if (tag.parentElement?.parentElement?.parentElement != null && tag.parentElement.parentElement.parentElement.classList.contains("show")) {
        tag.parentElement.parentElement.parentElement.classList.toggle('show')
        document.body.classList.toggle('no-scroll')
        document.body.parentElement!.classList.toggle('no-scroll')
    }
}

class NavbarLinks implements ClassComponent<HTMLDivElement> {
    mount(): HTMLDivElement {
        return l('div', _ => {
            css`
                display: flex;
                
                &>a {
                    text-decoration: none;
                    font-family: "Golos Text", sans-serif;
                    color: #001F19;
                }
                &>a:hover, &>a:active {
                    color: var(--base-color-dark-green);
                }    
            `.apply(_)

            l(_, 'a', _ => {
                _.href = '#projects'
                _.innerText = 'Важные проекты'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
            l(_, 'a', _ => {
                _.href = '#mains'
                _.innerText = 'Ключевые лица'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
            l(_, 'a', _ => {
                _.href = '#offer'
                _.innerText = 'Услуги'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
            l(_, 'a', _ => {
                _.href = '#blog'
                _.innerText = 'Блог'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
            l(_, 'a', _ => {
                _.href = '#project_stages'
                _.innerText = 'Этапы работы'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
            l(_, 'a', _ => {
                _.href = '#contacts'
                _.innerText = 'Контакты'
                _.onclick = () => {
                    MenuCloser(_)
                }
            })
        })
    }
}

const ui = l('div', _ => {
    css`
        max-width: 1440px;
        margin-left: auto;
        margin-right: auto;
    `.apply(_)

    let mobileNavbar: HTMLDivElement | null = null

    l(_, 'div', _ => {
        css`
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>div:nth-child(2) {
                align-items: center;
                gap: 37px;
                &>a {
                    font-size: 16px;
                }
            }
        `.apply(_)

        css`
            @media (max-width: 900px) {
                .this-class {
                    &>div:nth-child(2),
                    &>div:nth-child(3)>span,
                    &>div:nth-child(3)>div>a:nth-child(2),
                    &>div:nth-child(3)>div>a:nth-child(3) {
                        display: none;
                    }
                    &>div:nth-child(3)>div>div:nth-child(4) {
                        display: block;
                    }
                }
            }
        `.apply(_)

        l(_, 'div', _ => {
            css`
                width: 157px;
                height: 30px;
                background-image: url('data:image/svg+xml,<svg width="157" height="30" viewBox="0 0 157 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 29.3349V2.73218H9.03765C11.7088 2.73218 13.7391 3.23547 15.1286 4.24206C16.5301 5.24865 17.2308 6.7166 17.2308 8.6459C17.2308 11.8454 15.1047 14.1102 10.8524 15.4404C15.8234 16.6507 18.3089 19.0893 18.3089 22.7561C18.3089 24.8772 17.5782 26.5069 16.1168 27.6453C14.6675 28.7717 12.5832 29.3349 9.86416 29.3349H0ZM5.21057 13.8047H6.5222C8.07938 13.8047 9.31315 13.4212 10.2235 12.6543C11.1458 11.8874 11.607 10.8448 11.607 9.52666C11.607 8.30437 11.2357 7.47753 10.493 7.04614C9.76234 6.60276 8.37285 6.38107 6.32456 6.38107H5.21057V13.8047ZM5.21057 25.5602H6.39643C8.72023 25.5602 10.3193 25.3146 11.1938 24.8232C12.0801 24.32 12.5233 23.4092 12.5233 22.0911C12.5233 20.737 11.9304 19.6105 10.7446 18.7118C9.57069 17.8131 8.08537 17.3637 6.28862 17.3637H5.21057V25.5602Z" fill="%23005143"/><path d="M39.241 28.6699C36.7136 29.4128 34.3179 29.7843 32.054 29.7843C28.76 29.7843 26.1607 28.8496 24.2561 26.9802C22.3516 25.1108 21.3993 22.5584 21.3993 19.3229C21.3993 16.2672 22.2677 13.8107 24.0046 11.9533C25.7534 10.0839 28.0592 9.14919 30.9221 9.14919C33.8088 9.14919 35.917 10.0599 37.2466 11.8814C38.5762 13.7028 39.241 16.5848 39.241 20.5273H27.0051C27.3645 24.29 29.4308 26.1714 33.2039 26.1714C34.9887 26.1714 37.0011 25.7579 39.241 24.9311V28.6699ZM26.9333 17.5255H34.0125C34.0125 14.1582 32.9284 12.4745 30.7604 12.4745C28.5563 12.4745 27.2807 14.1582 26.9333 17.5255Z" fill="%23005143"/><path d="M48.638 13.607C50.291 11.0785 52.543 9.81426 55.3938 9.81426C57.7895 9.81426 59.676 10.6771 61.0536 12.4026C62.443 14.1282 63.1378 16.4709 63.1378 19.4308C63.1378 22.6902 62.2574 25.2307 60.4966 27.0521C58.7358 28.8736 56.2862 29.7843 53.1479 29.7843C49.746 29.7843 47.2545 28.7478 45.6734 26.6747C44.0922 24.5896 43.3017 21.3182 43.3017 16.8604C43.3017 11.408 44.218 7.39365 46.0507 4.81726C47.8954 2.24086 50.7642 0.952666 54.6571 0.952666H55.3938C57.1666 0.952666 58.7537 0.635111 60.1552 0V3.41522C59.0652 3.99041 57.6218 4.27801 55.825 4.27801H55.3938C53.1179 4.27801 51.4649 4.99101 50.4348 6.41702C49.4046 7.84302 48.8057 10.2397 48.638 13.607ZM48.638 16.9143L48.6201 17.5255C48.6201 20.3056 49.0333 22.4925 49.8598 24.0863C50.6983 25.6681 51.8422 26.459 53.2916 26.459C54.6452 26.459 55.6992 25.8478 56.4539 24.6255C57.2205 23.3913 57.6038 21.6956 57.6038 19.5386C57.6038 17.5974 57.2804 16.1414 56.6336 15.1708C55.9987 14.1881 55.0404 13.6968 53.7588 13.6968C51.95 13.6968 50.2431 14.7693 48.638 16.9143Z" fill="%23005143"/><path d="M79.5241 29.3349V25.1288L79.8116 24.7334C81.2371 22.828 82.6984 21.2223 84.1957 19.9161L86.3698 17.9928C89.9513 14.8292 91.742 12.0551 91.742 9.67046C91.742 6.89035 90.1609 5.5003 86.9986 5.5003C85.0462 5.5003 82.7823 6.15938 80.2069 7.47753V3.57699C82.914 2.5704 85.5313 2.06711 88.0587 2.06711C90.8856 2.06711 93.1495 2.73817 94.8504 4.08029C96.5513 5.41043 97.4018 7.19593 97.4018 9.43679C97.4018 10.9826 96.9886 12.3907 96.162 13.6609C95.3355 14.9311 93.8802 16.405 91.7959 18.0827L89.9992 19.5207C87.4957 21.5339 86.0104 23.4032 85.5433 25.1288H97.294V29.3349H79.5241Z" fill="%23005143"/><path d="M102.846 29.3349V23.565H108.614V29.3349H102.846Z" fill="%23005143"/><path d="M118.136 15.0809C115.573 13.3913 114.291 11.3541 114.291 8.96944C114.291 6.90833 115.1 5.24266 116.717 3.97244C118.334 2.69023 120.454 2.04913 123.077 2.04913C125.545 2.04913 127.515 2.59437 128.989 3.68484C130.474 4.77531 131.217 6.23128 131.217 8.05273C131.217 10.4014 129.719 12.6243 126.725 14.7214C130.51 16.6986 132.402 19.1851 132.402 22.1809C132.402 24.5177 131.48 26.405 129.635 27.843C127.791 29.281 125.371 30 122.377 30C119.514 30 117.202 29.3409 115.441 28.0228C113.692 26.7046 112.818 24.967 112.818 22.8101C112.818 19.6824 114.591 17.1061 118.136 15.0809ZM123.958 13.2115C125.731 11.8334 126.617 10.3595 126.617 8.78969C126.617 7.75914 126.252 6.93829 125.521 6.32714C124.79 5.70401 123.826 5.39245 122.628 5.39245C121.514 5.39245 120.61 5.66207 119.915 6.20132C119.232 6.74056 118.891 7.44757 118.891 8.32235C118.891 9.18514 119.232 9.94608 119.915 10.6052C120.598 11.2522 121.945 12.121 123.958 13.2115ZM120.76 16.8604C118.831 18.4661 117.867 20.1618 117.867 21.9473C117.867 23.3373 118.346 24.4817 119.304 25.3805C120.274 26.2792 121.502 26.7286 122.988 26.7286C124.293 26.7286 125.383 26.3751 126.258 25.6681C127.144 24.9611 127.587 24.0803 127.587 23.0258C127.587 22.115 127.288 21.3361 126.689 20.689C126.102 20.0419 124.952 19.2331 123.239 18.2624L120.76 16.8604Z" fill="%23005143"/><path d="M146.579 30C143.56 30 141.105 28.7058 139.212 26.1174C137.332 23.5291 136.391 20.1678 136.391 16.0336C136.391 11.8514 137.338 8.47813 139.23 5.91372C141.123 3.34931 143.614 2.06711 146.705 2.06711C149.771 2.06711 152.251 3.34931 154.143 5.91372C156.048 8.46615 157 11.8155 157 15.9617C157 20.2157 156.048 23.6189 154.143 26.1714C152.251 28.7238 149.729 30 146.579 30ZM146.633 26.6747C149.783 26.6747 151.358 23.1276 151.358 16.0336C151.358 8.93949 149.807 5.39245 146.705 5.39245C143.602 5.39245 142.051 8.93349 142.051 16.0156C142.051 23.1216 143.578 26.6747 146.633 26.6747Z" fill="%23005143"/></svg>');
            `.apply(_)
            css`
                @media(max-width: 1200px){
                    .this-class{
                        width: 81px;
                        height: 20px;
                        background-image: url('data:image/svg+xml, <svg width="81" height="20" viewBox="0 0 81 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 17.6675V4.36609H4.54761C5.8917 4.36609 6.91333 4.61774 7.6125 5.12103C8.31769 5.62433 8.67029 6.3583 8.67029 7.32295C8.67029 8.92271 7.60044 10.0551 5.46075 10.7202C7.96208 11.3253 9.21275 12.5446 9.21275 14.3781C9.21275 15.4386 8.84508 16.2534 8.10975 16.8226C7.38045 17.3859 6.33169 17.6675 4.96349 17.6675H0ZM2.62188 9.90234H3.28187C4.06542 9.90234 4.68624 9.71061 5.14431 9.32714C5.60842 8.94368 5.84047 8.42241 5.84047 7.76333C5.84047 7.15219 5.65362 6.73877 5.27993 6.52307C4.91226 6.30138 4.21309 6.19053 3.18242 6.19053H2.62188V9.90234ZM2.62188 15.7801H3.21859C4.38788 15.7801 5.19253 15.6573 5.63252 15.4116C6.07855 15.16 6.30156 14.7046 6.30156 14.0455C6.30156 13.3685 6.0032 12.8053 5.4065 12.3559C4.81582 11.9065 4.06844 11.6818 3.16434 11.6818H2.62188V15.7801Z" fill="%23005143"/><path d="M19.7455 17.3349C18.4737 17.7064 17.2683 17.8922 16.1291 17.8922C14.4716 17.8922 13.1637 17.4248 12.2053 16.4901C11.247 15.5554 10.7678 14.2792 10.7678 12.6615C10.7678 11.1336 11.2048 9.90533 12.0787 8.97663C12.9587 8.04194 14.119 7.5746 15.5595 7.5746C17.0121 7.5746 18.0729 8.02996 18.7419 8.94068C19.411 9.85141 19.7455 11.2924 19.7455 13.2636H13.5886C13.7694 15.145 14.8091 16.0857 16.7077 16.0857C17.6058 16.0857 18.6184 15.879 19.7455 15.4655V17.3349ZM13.5524 11.7627H17.1146C17.1146 10.0791 16.5691 9.23727 15.4781 9.23727C14.3691 9.23727 13.7272 10.0791 13.5524 11.7627Z" fill="%23005143"/><path d="M24.4739 9.80348C25.3057 8.53925 26.4388 7.90713 27.8733 7.90713C29.0788 7.90713 30.0281 8.33853 30.7212 9.20132C31.4204 10.0641 31.77 11.2355 31.77 12.7154C31.77 14.3451 31.327 15.6153 30.4409 16.5261C29.5549 17.4368 28.3223 17.8922 26.7432 17.8922C25.0314 17.8922 23.7778 17.3739 22.9821 16.3373C22.1865 15.2948 21.7887 13.6591 21.7887 11.4302C21.7887 8.70401 22.2498 6.69682 23.172 5.40863C24.1002 4.12043 25.5438 3.47633 27.5026 3.47633H27.8733C28.7654 3.47633 29.564 3.31756 30.2692 3V4.70761C29.7207 4.99521 28.9944 5.13901 28.0903 5.13901H27.8733C26.7281 5.13901 25.8964 5.49551 25.378 6.20851C24.8597 6.92151 24.5583 8.11983 24.4739 9.80348ZM24.4739 11.4572L24.4649 11.7627C24.4649 13.1528 24.6728 14.2463 25.0887 15.0431C25.5106 15.834 26.0862 16.2295 26.8155 16.2295C27.4966 16.2295 28.027 15.9239 28.4067 15.3128C28.7925 14.6956 28.9854 13.8478 28.9854 12.7693C28.9854 11.7987 28.8226 11.0707 28.4971 10.5854C28.1777 10.0941 27.6955 9.84841 27.0506 9.84841C26.1405 9.84841 25.2816 10.3847 24.4739 11.4572Z" fill="%23005143"/><path d="M40.0153 17.6675V15.5644L40.16 15.3667C40.8772 14.414 41.6126 13.6111 42.366 12.9581L43.4599 11.9964C45.2621 10.4146 46.1632 9.02756 46.1632 7.83523C46.1632 6.44518 45.3676 5.75015 43.7764 5.75015C42.7939 5.75015 41.6548 6.07969 40.3589 6.73877V4.7885C41.7211 4.2852 43.038 4.03355 44.3098 4.03355C45.7322 4.03355 46.8714 4.36908 47.7273 5.04014C48.5832 5.70521 49.0111 6.59796 49.0111 7.71839C49.0111 8.49131 48.8032 9.19533 48.3873 9.83044C47.9714 10.4655 47.2391 11.2025 46.1903 12.0413L45.2862 12.7603C44.0265 13.7669 43.2791 14.7016 43.0441 15.5644H48.9569V17.6675H40.0153Z" fill="%23005143"/><path d="M51.7505 17.6675V14.7825H54.6527V17.6675H51.7505Z" fill="%23005143"/><path d="M59.4444 10.5404C58.1545 9.69563 57.5096 8.67705 57.5096 7.48472C57.5096 6.45416 57.9165 5.62133 58.7301 4.98622C59.5438 4.34512 60.6107 4.02457 61.9306 4.02457C63.1723 4.02457 64.1638 4.29718 64.9051 4.84242C65.6525 5.38766 66.0262 6.11564 66.0262 7.02636C66.0262 8.20072 65.2728 9.31216 63.766 10.3607C65.6706 11.3493 66.6229 12.5926 66.6229 14.0905C66.6229 15.2588 66.1588 16.2025 65.2306 16.9215C64.3024 17.6405 63.0849 18 61.578 18C60.1375 18 58.9743 17.6705 58.0882 17.0114C57.2082 16.3523 56.7683 15.4835 56.7683 14.405C56.7683 12.8412 57.6603 11.553 59.4444 10.5404ZM62.3737 9.60575C63.2657 8.91672 63.7117 8.17975 63.7117 7.39485C63.7117 6.87957 63.5279 6.46914 63.1602 6.16357C62.7925 5.85201 62.3074 5.69623 61.7046 5.69623C61.1441 5.69623 60.689 5.83104 60.3394 6.10066C59.9959 6.37028 59.8241 6.72379 59.8241 7.16117C59.8241 7.59257 59.9959 7.97304 60.3394 8.30258C60.683 8.62612 61.3611 9.06052 62.3737 9.60575ZM60.7644 11.4302C59.794 12.2331 59.3088 13.0809 59.3088 13.9736C59.3088 14.6687 59.5499 15.2409 60.032 15.6902C60.5203 16.1396 61.1381 16.3643 61.8854 16.3643C62.5424 16.3643 63.0909 16.1875 63.5309 15.834C63.9769 15.4805 64.1999 15.0401 64.1999 14.5129C64.1999 14.0575 64.0492 13.6681 63.7479 13.3445C63.4525 13.021 62.8739 12.6165 62.012 12.1312L60.7644 11.4302Z" fill="%23005143"/><path d="M73.7562 18C72.2374 18 71.0018 17.3529 70.0494 16.0587C69.1031 14.7645 68.63 13.0839 68.63 11.0168C68.63 8.9257 69.1062 7.23907 70.0585 5.95686C71.0108 4.67466 72.2645 4.03355 73.8195 4.03355C75.3625 4.03355 76.6102 4.67466 77.5625 5.95686C78.5208 7.23307 79 8.90773 79 10.9808C79 13.1079 78.5208 14.8095 77.5625 16.0857C76.6102 17.3619 75.3414 18 73.7562 18ZM73.7834 16.3373C75.3685 16.3373 76.1611 14.5638 76.1611 11.0168C76.1611 7.46974 75.3806 5.69623 73.8195 5.69623C72.2585 5.69623 71.4779 7.46675 71.4779 11.0078C71.4779 14.5608 72.2464 16.3373 73.7834 16.3373Z" fill="%23005143"/></svg>');
                    }
                }
            `.apply(_)
        })

        l(_, new NavbarLinks())

        l(_, 'div', _ => {
            css`
                display: flex;
                align-items: center;
                gap: 16px;
            `.apply(_)

            l(_, 'span', _ => {
                css`
                    font-size: 16px;
                    font-family: "Golos Text", sans-serif;
                `.apply(_)
                _.innerText = '+7 913 610 67 42'
            })

            l(_, 'div', _ => {
                css`
                    display: flex;
                    gap: 10px;

                    &>a, &>div{
                        width: 40px;
                        height: 40px;
                        padding: 8px;
                        background-repeat: no-repeat;
                        background-position: 8px 8px;
                        border: 1px solid #2ACBB0;
                        border-radius: 4px;
                    }
                `.apply(_)
                l(_, 'a', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.9359 2.44444C21.1909 1.92344 20.2529 1.84544 19.4299 2.23744L1.94194 11.4494C0.629936 12.1404 0.706936 14.0304 2.05794 14.6394C2.34694 14.7694 2.59894 14.8674 2.79594 14.9214L4.93994 15.4574C5.67894 15.6434 6.47094 15.5064 7.10694 15.0824L16.1949 8.10344C16.4019 7.94544 16.6939 7.97044 16.8679 8.16244C17.0439 8.35244 17.0439 8.64544 16.8689 8.83744L10.3249 16.0064C10.0329 16.3004 9.89793 16.6824 9.94094 17.0714C9.98394 17.4604 10.1979 17.8034 10.5279 18.0134L10.5629 18.0314L18.5079 21.8144C19.7249 22.3944 21.1499 21.5984 21.2959 20.2584L22.9869 4.72744C23.0749 3.82044 22.6829 2.96744 21.9359 2.44444Z" fill="%232ACBB0"/></svg>');
                    `.apply(_)
                    _.ariaLabel="написать в telegram"
                    _.href = "https://t.me/aka_naked_gun"
                    _.target = "_blank"
                })
                l(_, 'a', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3311 2.13521C6.33306 2.78121 3.05906 5.90321 2.22506 9.86621C1.65606 12.5662 2.20206 15.1102 3.45606 17.1762L3.01706 20.8302C2.89006 21.5692 3.59206 22.1792 4.30606 21.9522L7.51906 20.9302C9.39406 21.8732 11.5981 22.2612 13.9261 21.8152C18.0041 21.0342 21.2471 17.6902 21.8781 13.5852C22.9211 6.79721 17.1281 1.03621 10.3311 2.13521ZM16.9591 15.5132C16.8871 15.9552 16.6171 16.3382 16.2271 16.5572C15.6441 16.8842 14.8791 17.0722 14.1701 16.9742C13.4331 16.8722 12.6601 16.5402 11.8831 16.0542C10.6071 15.2962 9.71006 14.3532 9.65306 14.2932C9.62306 14.2672 8.65906 13.3412 7.89306 12.0322C7.43506 11.2832 7.12106 10.5382 7.02306 9.82721C7.02006 9.80621 7.02306 9.78521 7.02006 9.76421C7.02006 9.76321 7.01906 9.76221 7.01906 9.76121C6.94106 9.07121 7.12306 8.33621 7.44006 7.77021C7.65906 7.38021 8.04206 7.11021 8.48406 7.03821C8.85006 6.97821 9.32706 6.95821 9.77406 7.11621C9.90306 7.16221 10.0181 7.25321 10.1021 7.36121C10.5151 7.89621 10.8051 8.53021 10.9371 8.91321C11.0271 9.17421 10.9571 9.45921 10.7681 9.65821L10.6731 9.75321L9.98006 10.4152C9.98006 10.4152 9.98006 10.4312 9.98106 10.4462L9.54006 10.8872C10.0431 11.7902 10.7411 12.5712 11.0721 12.8842C11.1171 12.9302 11.9911 13.8442 13.1111 14.4592L13.5521 14.0182C13.5661 14.0182 13.5831 14.0192 13.5831 14.0192L14.2441 13.3272L14.3391 13.2322C14.5381 13.0432 14.8231 12.9742 15.0841 13.0632C15.4671 13.1952 16.1021 13.4852 16.6361 13.8982C16.7451 13.9822 16.8361 14.0962 16.8811 14.2262C17.0391 14.6702 17.0191 15.1472 16.9591 15.5132Z" fill="%232ACBB0"/></svg>');
                    `.apply(_)
                    _.ariaLabel="написать в whatsapp"
                    _.href = "https://wa.me/79059221424"
                    _.target = "_blank"
                })
                l(_, 'a', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9149 3.08594H3.08777C1.86215 3.08594 0.870517 4.08871 0.870517 5.31433L0.859375 18.6847C0.859375 19.9103 1.86215 20.9131 3.08777 20.9131H20.9149C22.1405 20.9131 23.1433 19.9103 23.1433 18.6847V5.31433C23.1433 4.08871 22.1405 3.08594 20.9149 3.08594ZM20.4692 7.82127L12.5919 12.746C12.2353 12.9689 11.7674 12.9689 11.4108 12.746L3.53345 7.82127C3.42172 7.75856 3.32389 7.67382 3.24586 7.5722C3.16783 7.47058 3.11124 7.35418 3.0795 7.23005C3.04776 7.10592 3.04153 6.97664 3.0612 6.85004C3.08087 6.72343 3.12603 6.60213 3.19393 6.49349C3.26184 6.38484 3.35108 6.2911 3.45626 6.21794C3.56144 6.14478 3.68038 6.09372 3.80586 6.06786C3.93135 6.042 4.06078 6.04186 4.18632 6.06747C4.31185 6.09308 4.43089 6.14389 4.53622 6.21683L12.0013 10.8853L19.4665 6.21683C19.5718 6.14389 19.6908 6.09308 19.8164 6.06747C19.9419 6.04186 20.0713 6.042 20.1968 6.06786C20.3223 6.09372 20.4412 6.14478 20.5464 6.21794C20.6516 6.2911 20.7408 6.38484 20.8088 6.49349C20.8767 6.60213 20.9218 6.72343 20.9415 6.85004C20.9612 6.97664 20.9549 7.10592 20.9232 7.23005C20.8915 7.35418 20.8349 7.47058 20.7568 7.5722C20.6788 7.67382 20.581 7.75856 20.4692 7.82127Z" fill="%232ACBB0"/></svg>');
                    `.apply(_)
                    _.ariaLabel="написать на почту"
                    _.href = "mailto:welcome@web280.ru"
                    _.target = "_blank"
                })
                l(_, 'div', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="18" height="1" rx="0.5" fill="%232ACBB0"/><rect y="6.5" width="18" height="1" rx="0.5" fill="%232ACBB0"/><rect y="12.5" width="18" height="1" rx="0.5" fill="%232ACBB0"/></svg>');
                        background-position: 11px 12px !important;
                        display: none;
                    `.apply(_)
                    _.onclick = () => {
                        if (mobileNavbar != null) {
                            mobileNavbar.classList.toggle('show')
                            document.body.classList.toggle('no-scroll')
                            document.body.parentElement!.classList.toggle('no-scroll')
                        }
                    }
                })
            })
        })
    })
    l(_, 'div', _ => {
        mobileNavbar = _
        css`
            display: flex;
            justify-content: flex-end;
            position: fixed;
            top: 50px;
            left: 0;
            width: 100vw;
            height: 0;
            overflow-y: hidden;
            transition: height 0.4s;
        `.apply(_)
        css`
            .this-class.show {
                height: calc(100dvh - 50px);
            }
        `.apply(_)

        l(_, 'div', _ => {
            css`
                padding-left: 20px;
                padding-right: 20px;
                padding-top: 42px;
                max-width: 442px;
                width: 100%;
                background-color: white;
                overflow-y: scroll;

                &>div:nth-child(1) {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 30px;
                    &>a {
                        font-size: 18px;
                    }
                }
            `.apply(_)

            l(_, new NavbarLinks())
            l(_, 'a', _ => {
                css`
                    margin-top: 40px;
                    text-decoration: none;
                `.apply(_)

                _.href = linkToPresentation
                _.download = "Web 2.80 Презентация"

                stFlexyButton.apply(_)

                l(_, 'div', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 22H10C6.713 22 5.069 22 3.962 21.092C3.75965 20.9259 3.57409 20.7404 3.408 20.538C2.5 19.43 2.5 17.788 2.5 14.5C2.5 11.213 2.5 9.569 3.408 8.462C3.57409 8.25965 3.75965 8.07409 3.962 7.908C5.07 7 6.712 7 10 7H14C17.288 7 18.931 7 20.038 7.908C20.2404 8.07409 20.4259 8.25965 20.592 8.462C21.5 9.569 21.5 11.212 21.5 14.5C21.5 17.788 21.5 19.431 20.592 20.538C20.4259 20.7404 20.2404 20.9259 20.038 21.092C18.931 22 17.288 22 14 22Z" stroke="%232ACBB0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.5 15V11C2.5 7.229 2.5 5.343 3.672 4.172C4.844 3.001 6.729 3 10.5 3H13.5C17.271 3 19.157 3 20.328 4.172C21.499 5.344 21.5 7.229 21.5 11V15M15 15C15 15 12.79 18 12 18C11.21 18 9 15 9 15M12 17.5V11" stroke="%232ACBB0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
                    `.apply(_)
                })

                l(_, 'span', _ => {
                    _.innerText = 'Скачать презентацию команды'
                })
            })

            l(_, 'div', _ => {
                css`
                    border-top: 1px solid #ECECEC;
                    margin-top: 30px;
                    padding-top: 28px;
                    padding-bottom: 16px;
                    font-family: "Golos Text", sans-serif;
                    &>p {
                        margin-bottom: 20px;
                    }
                `.apply(_)

                l(_, 'p', _ => {
                    css`
                        color: var(--base-color-dark-green);
                        font-size: 12px;
                    `.apply(_)
                    _.innerText = 'Для связи'
                })
                l(_, 'p', _ => {
                    css`
                        color: #001F19;
                        font-size: 18px;
                    `.apply(_)
                    _.innerText = 'welcome@web280.ru'
                })
                l(_, 'p', _ => {
                    css`
                        color: #001F19;
                        font-size: 18px;
                    `.apply(_)
                    _.innerText = '+7 913 610 67 42'
                })
            })

            l(_, 'a', _ => {
                stFlexyButton.apply(_)
                css`
                    text-decoration: none;
                `.apply(_)
                l(_, 'div', _ => {
                    css`
                        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.29973 8.19371 4.21192 8.11766 4.14189 8.02645C4.07186 7.93525 4.02106 7.83078 3.99258 7.71937C3.96409 7.60796 3.9585 7.49194 3.97616 7.37831C3.99381 7.26468 4.03434 7.15581 4.09528 7.0583C4.15623 6.96079 4.23632 6.87666 4.33073 6.811C4.42513 6.74533 4.53187 6.69951 4.6445 6.6763C4.75712 6.65309 4.87328 6.65297 4.98595 6.67595C5.09863 6.69893 5.20546 6.74453 5.3 6.81L12 11L18.7 6.81C18.7945 6.74453 18.9014 6.69893 19.014 6.67595C19.1267 6.65297 19.2429 6.65309 19.3555 6.6763C19.4681 6.69951 19.5749 6.74533 19.6693 6.811C19.7637 6.87666 19.8438 6.96079 19.9047 7.0583C19.9657 7.15581 20.0062 7.26468 20.0238 7.37831C20.0415 7.49194 20.0359 7.60796 20.0074 7.71937C19.9789 7.83078 19.9281 7.93525 19.8581 8.02645C19.7881 8.11766 19.7003 8.19371 19.6 8.25Z" fill="%232ACBB0"/></svg>');
                    `.apply(_)
                })
                l(_, 'span', _ => { _.innerText = 'Написать на почту' })
                _.href = "mailto:welcome@web280.ru"
                _.target = "_blank"

            })
            l(_, 'div', _ => {
                css`
                    margin-top: 10px;
                    margin-bottom: 30px;
                    display: flex;
                    gap: 10px;
                    &>a {
                        flex-grow: 1;
                        flex-shrink: 1;
                        min-width: 100px;
                    }
                `.apply(_)
                l(_, 'a', _ => {
                    stFlexyButton.apply(_)
                    css`
                        text-decoration: none;
                    `.apply(_)
                    l(_, 'div', _ => {
                        css`
                            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21.9359 2.44444C21.1909 1.92344 20.2529 1.84544 19.4299 2.23744L1.94194 11.4494C0.629936 12.1404 0.706936 14.0304 2.05794 14.6394C2.34694 14.7694 2.59894 14.8674 2.79594 14.9214L4.93994 15.4574C5.67894 15.6434 6.47094 15.5064 7.10694 15.0824L16.1949 8.10344C16.4019 7.94544 16.6939 7.97044 16.8679 8.16244C17.0439 8.35244 17.0439 8.64544 16.8689 8.83744L10.3249 16.0064C10.0329 16.3004 9.89793 16.6824 9.94094 17.0714C9.98394 17.4604 10.1979 17.8034 10.5279 18.0134L10.5629 18.0314L18.5079 21.8144C19.7249 22.3944 21.1499 21.5984 21.2959 20.2584L22.9869 4.72744C23.0749 3.82044 22.6829 2.96744 21.9359 2.44444Z" fill="%232ACBB0"/></svg>');
                        `.apply(_)
                    })
                    l(_, 'span', _ => { _.innerText = 'Telegram' })
                    _.href = "https://t.me/aka_naked_gun"
                    _.target = "_blank"
                })
                l(_, 'a', _ => {
                    stFlexyButton.apply(_)
                    css`
                        text-decoration: none;
                    `.apply(_)
                    l(_, 'div', _ => {
                        css`
                            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.3311 2.13521C6.33306 2.78121 3.05906 5.90321 2.22506 9.86621C1.65606 12.5662 2.20206 15.1102 3.45606 17.1762L3.01706 20.8302C2.89006 21.5692 3.59206 22.1792 4.30606 21.9522L7.51906 20.9302C9.39406 21.8732 11.5981 22.2612 13.9261 21.8152C18.0041 21.0342 21.2471 17.6902 21.8781 13.5852C22.9211 6.79721 17.1281 1.03621 10.3311 2.13521ZM16.9591 15.5132C16.8871 15.9552 16.6171 16.3382 16.2271 16.5572C15.6441 16.8842 14.8791 17.0722 14.1701 16.9742C13.4331 16.8722 12.6601 16.5402 11.8831 16.0542C10.6071 15.2962 9.71006 14.3532 9.65306 14.2932C9.62306 14.2672 8.65906 13.3412 7.89306 12.0322C7.43506 11.2832 7.12106 10.5382 7.02306 9.82721C7.02006 9.80621 7.02306 9.78521 7.02006 9.76421C7.02006 9.76321 7.01906 9.76221 7.01906 9.76121C6.94106 9.07121 7.12306 8.33621 7.44006 7.77021C7.65906 7.38021 8.04206 7.11021 8.48406 7.03821C8.85006 6.97821 9.32706 6.95821 9.77406 7.11621C9.90306 7.16221 10.0181 7.25321 10.1021 7.36121C10.5151 7.89621 10.8051 8.53021 10.9371 8.91321C11.0271 9.17421 10.9571 9.45921 10.7681 9.65821L10.6731 9.75321L9.98006 10.4152C9.98006 10.4152 9.98006 10.4312 9.98106 10.4462L9.54006 10.8872C10.0431 11.7902 10.7411 12.5712 11.0721 12.8842C11.1171 12.9302 11.9911 13.8442 13.1111 14.4592L13.5521 14.0182C13.5661 14.0182 13.5831 14.0192 13.5831 14.0192L14.2441 13.3272L14.3391 13.2322C14.5381 13.0432 14.8231 12.9742 15.0841 13.0632C15.4671 13.1952 16.1021 13.4852 16.6361 13.8982C16.7451 13.9822 16.8361 14.0962 16.8811 14.2262C17.0391 14.6702 17.0191 15.1472 16.9591 15.5132Z" fill="%232ACBB0"/></svg>');
                        `.apply(_)
                    })
                    l(_, 'span', _ => { _.innerText = 'WhatsApp' })
                    _.href = "https://wa.me/79059221424"
                    _.target = "_blank"
                })
            })

        })
    })

    l(_, 'div', _ => {
        css`
            display: flex;
            flex-direction: column;
            row-gap: clamp(80px, 16.67vw, 200px);
            margin-top: clamp(40px, 6.67vw, 80px);
            h1, 
            h2, 
            p {
                margin: 0px;
            }
        `.apply(_)
        l(_, new TitleAndDescription())
        l(_, new ImportantProjects())
        l(_, new KeyPeople())
        l(_, new Services())
        l(_, new Blog())
        l(_, new WorkStages())
        l(_, new YourProblemsAndTasks())

    })

    l(_, new Footer())

})

document.body.appendChild(ui)